<template id="cmsForm">
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a href="/">Home</a></li>
        <li class="breadcrumb-item"><a href="/cms_category">cms category</a></li>
        <li class="breadcrumb-item active" aria-current="page">cms category form</li>
      </ol>
    </nav>
    <div class="row">
      <div class="col-md-10">
        <h3>
          ฟอร์ม CMS category (<span v-if="item_id">แก้ไข</span
          ><span v-if="!item_id">เพิ่มใหม่</span>)
        </h3>
      </div>
    </div>
    <form>
      <div class="row">
        <div class="col-md-3">
          <div class="form-group">
            <label for="post_category_language_id">ภาษา</label>
            <select
              class="form-control"
              id="post_category_language_id"
              v-model="form.language"
            >
              <option></option>
              <option
                v-for="language in languages"
                v-bind:key="language.id"
                :value="language.code"
              >
                {{ language.name }}, {{ language.localize }}
              </option>
            </select>
            <form-error
              :isError="validateError.language.error"
              :errorMessage="validateError.language.message"
            ></form-error>
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label for="post_category_name">ชื่อ category</label>
            <input
              type="text"
              class="form-control"
              id="post_category_name"
              v-model="form.name"
            />
            <form-error
              :isError="validateError.name.error"
              :errorMessage="validateError.name.message"
            ></form-error>
          </div>
        </div>

        <div class="col-md-3">
          <div class="form-group">
            <label for="post_status">ปิดการใช้งาน</label>
            <select
              class="form-control"
              id="post_status"
              v-model="form.disabled"
            >
              <option :value="0">ไม่</option>
              <option :value="1">ใช่</option>
            </select>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label for="post_category_slug">slug</label>
            <input
              type="text"
              class="form-control"
              id="post_category_slug"
              v-model="form.slug"
            />
            <form-error
              :isError="validateError.slug.error"
              :errorMessage="validateError.slug.message"
            ></form-error>
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label for="post_category_taxonomy">taxonomy</label>
            <input
              type="text"
              class="form-control"
              id="post_category_taxonomy"
              v-model="form.taxonomy"
            />
            <form-error
              :isError="validateError.taxonomy.error"
              :errorMessage="validateError.taxonomy.message"
            ></form-error>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label for="post_category_head">head</label>
            <input
              type="text"
              class="form-control"
              id="post_category_head"
              v-model="form.head"
            />
            <form-error
              :isError="validateError.head.error"
              :errorMessage="validateError.head.message"
            ></form-error>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label for="post_category_description">Description</label>
            <input
              type="text"
              class="form-control"
              id="post_category_description"
              v-model="form.description"
            />
            <form-error
              :isError="validateError.description.error"
              :errorMessage="validateError.description.message"
            ></form-error>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="form-group float-right">
            <a
              href="javascript:void(0)"
              onclick="javascript:window.history.back(); return false;"
              class="btn btn-secondary"
              >ยกเลิก</a
            >
            <button
              type="button"
              class="btn btn-primary ml-5"
              @click="saveWithGoBack()"
            >
              บันทึก
            </button>
            <button
              type="button"
              v-if="!this.item_id"
              class="btn btn-primary ml-5"
              @click="saveWithMore()"
            >
              บันทึก และ บันทึกเพิ่ม
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  props: {
    //item_id ถูกส่งผ่านมาทาง form.blade.php ใน tag component (:item_id="{{empty($id) ? '0' : $id}}")
    //กรณีที่เป็น การ add item_id จะ เท่ากับ 0
    item_id: "",
  },
  data() {
    return {
      form: {
        //ชื่อฟิลด์ต่างๆในฟอร์มที่จะ add หรือ edit ชื่อฟิลด์จะเหมือนกับใน postman
        name: "",
        language: "",
        disabled: 0,

        slug: "",
        taxonomy: "",
        head: "",
        description: "",
      },
      validateError: {
        // เก็บตัวแปรผลการ submit form ว่ามีฟิลด์ไหน error บ้าง ซึ่งจะ bind กับ ตัวแปรใน <form-error> ให้เลือกเฉพาะฟิลด์ที่ต้อง validate สามารถดูว่าฟิลด์ไหน validate หรือไม่ให้ดูได้ที่ app-backend/app/controller/controller นั้นๆ
        name: { error: false, message: "" },
        language: { error: false, message: "" },

        slug: { error: false, message: "" },
        taxonomy: { error: false, message: "" },
        head: { error: false, message: "" },
        description: { error: false, message: "" },
      },
      languages: {
        // เอาไว้เก็บตัวเลือกภาษาใน form select language โดย method fetchLanguages จะไปดึงมาให้จาก laravel
      },
      base_url: "/cms_category", // base url (เปลี่ยน)
    };
  },
  mounted() {},
  beforeMount() {},
  created() {
    this.fetchLanguages();
    if (this.item_id) {
      //ถ้าเป็นการแก้ไข ให้ไปดึงข้อมูลเดิมมาใส่ฟอร์มด้วยฟังก์ชั่น load(this.item_id)
      this.load(this.item_id);
    }
  },
  methods: {
    load(id) {
      axios
        .get(this.base_url + "/" + id)
        .then((response) => {
          console.log(response.data);
          //เอาข้อมูลแต่ละฟิลด์ใส่ฟอร์มหลังจากโหลดมาแล้ว
          this.form.name = response.data.post[0].name;
          this.form.language = response.data.post[0].language.code;
          this.form.disabled = response.data.post[0].disabled;

          this.form.description = response.data.post[0].description;
          this.form.slug = response.data.post[0].slug;
          this.form.head = response.data.post[0].head;
          this.form.taxonomy = response.data.post[0].taxonomy;
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    saveWithGoBack() {
      this.save("");
    },
    saveWithMore() {
      this.save("more");
    },
    save(whatNext) {
      let save_url = "";
      if (this.item_id != "") {
        save_url = this.base_url + "/" + this.item_id + "/update";
      } else {
        save_url = this.base_url;
      }
      let me = this;
      console.log(this.form);
      axios
        .post(save_url, this.form)
        .then((response) => {
          console.log(response);
          // this.languages = response.data.items;
          this.validateError.name.error = false;
          this.validateError.language.error = false;
          if (whatNext == "more") {
            this.form.name = "";
            this.form.language = "";
            this.form.description = "";
            this.form.slug = "";
            this.form.head = "";
            this.form.taxonomy = "";
          } else {
            window.location.href = this.base_url;
          }
        })
        .catch((errors) => {
          if (errors.response.data.message) {
            let errorMessage = errors.response.data.message;
            let fields = Object.keys(this.form);
            fields.forEach(function (item) {
              // console.log(item);
              if (typeof errorMessage[item] != "undefined") {
                me.validateError[item].error = true;
                me.validateError[item].message = errorMessage[item][0];
              }
            });
          } else {
            console.log(errors.response.data._infos.result);
            alert("ไม่สามารถบันทึกได้ " + errors.response.data);
          }
        });
    },
    fetchLanguages(url) {
      url = url || "/fetch/language";
      axios
        .get(url)
        .then((response) => {
          this.languages = response.data.items;
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
  },
};
</script>